module.exports = __webpack_public_path__ + "static/media/marion15.c5092efa.png";